
const AGREEMENT_VALUES = {
  NO: 'no',
  AGREEMENT: 'agreement',
  YES: 'yes',
};

export {
  AGREEMENT_VALUES,
};
